import SearchAutocomplete from './SearchAutocomplete';
import HomepageSearchAutocomplete from './Homepage/HomepageSearchAutocomplete';

export * from './utils';
export { HomepageSearchAutocomplete };
export default SearchAutocomplete;
